/* Lumetier Landing — shared constants.
   Brand tokens + static product/feature/pricing data used across sections.
   Kept here so individual section files stay focused on layout, not data. */

import {
  Calendar, ImagePlus, FileSignature, CreditCard, Star, Clock,
  Images, Globe, LayoutDashboard, ShoppingBag,
} from "lucide-react";

export const GOLD = "#C9A961";
export const GOLD_LIGHT = "#EDD78C";

export const FEATURES = [
  { icon: Calendar, name: "Bookings & calendar", body: "Clients pick a service, a date, and a time — then pay a deposit before the slot is reserved. No more chasing." },
  { icon: ImagePlus, name: "Branded galleries", body: "Beautiful proofing galleries with favorites, comments, and password-protected downloads. Your name on the URL, not ours." },
  { icon: FileSignature, name: "Contracts & e-signature", body: "Reusable templates · Auto-fill from booking · One-tap signing on any device · PDF saved to the client record." },
  { icon: CreditCard, name: "Invoices & payments", body: "Send an invoice, accept a deposit, mark a balance paid — all in one record. Zelle, Stripe, or your own flow." },
  { icon: Star, name: "Auto-review requests", body: "The day after delivery, your happiest clients get a one-tap review prompt. Build your social proof on autopilot." },
  { icon: Clock, name: "Reminders that show up", body: "Email AND push notifications for upcoming sessions, balances due, and gallery deadlines. Native-app feel from your browser." },
];

export const PRICING = [
  {
    name: "Solo", price: 29,
    line: "For independent photographers, just starting out or running on the side.",
    features: ["1 user", "Up to 20 bookings/mo", "5 active galleries", "Contracts & e-sign", "Email + push reminders"],
    highlight: false,
  },
  {
    name: "Studio", price: 69,
    line: "For full-time photographers running 20–80 sessions a month.",
    features: ["Unlimited bookings", "Unlimited galleries", "Custom branded URL", "Resend / Stripe / Zelle", "Priority support"],
    highlight: true,
  },
  {
    name: "Pro", price: 129,
    line: "For multi-shooter studios or agencies serving 100+ clients/mo.",
    features: ["3 team seats", "White-label client portal", "Advanced reporting", "API access (coming soon)", "Dedicated onboarding"],
    highlight: false,
  },
];

/* Single source of truth for the Products dropdown (nav) + mobile panel.
   Each item mirrors the matching tile in the Inside Lumetier section so the
   nav and the page tell the same story. */
export const LUMETIER_PRODUCTS = [
  {
    id: "galleries",
    title: "Client galleries",
    short: "Branded delivery, proofs, selections, downloads",
    to: "/lumetier/galleries",
    icon: Images,
    iconBg: "rgba(201, 169, 97, 0.12)",   // gold-tinted
    iconColor: "#C9A961",
    ready: true,
  },
  {
    id: "website",
    title: "Studio website",
    short: "Booking-ready boutique site at your own subdomain",
    to: "/lumetier/website",
    icon: Globe,
    iconBg: "rgba(122, 163, 149, 0.14)",  // muted teal
    iconColor: "#9BC0B0",
    ready: true,
  },
  {
    id: "manager",
    title: "Studio manager",
    short: "Bookings, contracts, payments, clients — one dashboard",
    to: "/lumetier/manager",
    icon: LayoutDashboard,
    iconBg: "rgba(232, 217, 181, 0.12)",  // champagne
    iconColor: "#E8D9B5",
    ready: true,
  },
  {
    id: "store",
    title: "Print store",
    short: "Sell prints, albums, downloads directly from galleries",
    to: "/lumetier/store",
    icon: ShoppingBag,
    iconBg: "rgba(181, 138, 130, 0.12)",  // muted rose
    iconColor: "#C9A0A0",
    ready: false,
  },
];
